module.exports = __webpack_public_path__ + "static/img/200260.018598f2.png";